import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Attributes } from "../Utils/Attributes";

/**
 * The payline element is used for hold payline special cases and handle payline behaviour on screen.
 * @class Symbol
 * @extends SwitchElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Payline extends SwitchElement {
    //base payline cases
    static CaseSelect: string = "SELECT";

    static CaseNormal: string = "NORMAL";
    static CaseNowin: string = "NOWIN";
    static CaseWin: string = "WIN";
    static CaseFirstWin: string = "FIRST_WIN";
    static CaseSingleWin: string = "SINGLE_WIN";
    static CaseSingleCycle: string = "SINGLE_CYCLE";
    static CaseCycle: string = "CYCLE";

    zIndex: number = 0;

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    createByNode(node: Element): void {
        super.createByNode(node);

        this.zIndex = Attributes.assignFloatAttribute(node, PaylineAttributes.Z_INDEX, this.zIndex);
    }
}

export const PaylineAttributes = {
    /**
     * Z-index of symbol on screen
     * @property Zindex
     * @default 0
     */
    Z_INDEX: "Zindex",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Payline.ts
 **/